import React from "react";

var ShieldIcon = function ShieldIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 0L2 6v6c.131 4.865 1.794 9.316 10 12 8.206-2.684 9.869-7.135 10-12V6zm8 11.973l-.001.027H12v9.888C5.566 19.613 4.127 16.28 4.001 12H12V2.332l8 4.8z"
  }));
};

ShieldIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
ShieldIcon.defaultProps.solid = true;
export default ShieldIcon;